import actionCreator from './actionCreator';
import * as actionTypes from './actionTypes';
import * as actions from './actions';
import * as constants from './constants';
import reducer from './reducer';
import * as selectors from './selectors';

const Modal = {
  actionCreator,
  actions,
  actionTypes,
  reducer,
  selectors,
  constants,
};

export default Modal;
